import { render, staticRenderFns } from "./CopyPlano.vue?vue&type=template&id=4222df90&"
import script from "./CopyPlano.vue?vue&type=script&lang=js&"
export * from "./CopyPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports